import { render, staticRenderFns } from "./server-income.vue?vue&type=template&id=0bdb26d2&scoped=true&"
import script from "./server-income.vue?vue&type=script&lang=js&"
export * from "./server-income.vue?vue&type=script&lang=js&"
import style0 from "./server-income.vue?vue&type=style&index=0&id=0bdb26d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb26d2",
  null
  
)

export default component.exports